import { createSelector } from 'reselect';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { buildMarketConfig } from '../utils/marketConfigUtils';

export const getMarketConfig = createSelector(
  getActiveLocaleSelector,
  (locale) => buildMarketConfig(locale)
);

export const getMarketConfigDefaultTime = createSelector(
  getMarketConfig,
  ({ DEFAULT_TIME } = {}) => DEFAULT_TIME
);

export default getMarketConfig;
